import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { authApi } from "~/api";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: "/sign-in",
        search: {
          // Save current location for redirect after login
          redirect: location.href,
        },
      });
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(authApi.queries.roles);
  },
  component: Outlet,
});
